import _actions_get from './_actions/get.js'
import _getters_row_name from './_getters/row/name.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_items from './_mutations/items.js'
import _mutations_clean from './_mutations/clean.js'
import _mutations_cb from './_mutations/cb.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        cb: _mutations_cb,
        clean: _mutations_clean,
        items: _mutations_items,
        loading: _mutations_loading,
    },
    getters:{
        row_name: _getters_row_name,
    },
    actions:{
        get: _actions_get,
    },
}